import { render, staticRenderFns } from "./DisplaySecurity.vue?vue&type=template&id=6aa0c47f&scoped=true"
import script from "./DisplaySecurity.vue?vue&type=script&lang=js"
export * from "./DisplaySecurity.vue?vue&type=script&lang=js"
import style0 from "./DisplaySecurity.vue?vue&type=style&index=0&id=6aa0c47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0c47f",
  null
  
)

export default component.exports